import request from '@/services/interceptor.js'

export const get_aziende = () => {
    return request({ url: '/tenant', method: 'get', loadingBar: true })
}

export const get_azienda = (id) => {
    return request({ url: `/tenant/${id}`, method: 'get', loadingBar: true })
}

// Creazione combinata: azienda + il suo unico utente collegato, in un solo passaggio.
export const create_azienda = (par) => {
    return request({ url: '/tenant', method: 'post', data: par, loadingBar: true })
}

export const update_azienda = (id, par) => {
    return request({ url: `/tenant/${id}`, method: 'put', data: par, loadingBar: true })
}

export const attiva_azienda = (id) => {
    return request({ url: `/tenant/${id}/attiva`, method: 'put', loadingBar: true })
}

export const disattiva_azienda = (id) => {
    return request({ url: `/tenant/${id}/disattiva`, method: 'put', loadingBar: true })
}

// Gestione dell'unico utente collegato all'azienda (mai una lista, vedi TenantController).
export const crea_utente_azienda = (id, par) => {
    return request({ url: `/tenant/${id}/utente`, method: 'post', data: par, loadingBar: true })
}

export const reset_password_utente_azienda = (id, nuovaPassword) => {
    return request({ url: `/tenant/${id}/utente/reset-password`, method: 'post', data: { nuovaPassword }, loadingBar: true })
}

export const abilita_utente_azienda = (id) => {
    return request({ url: `/tenant/${id}/utente/abilita`, method: 'put', loadingBar: true })
}

export const disabilita_utente_azienda = (id) => {
    return request({ url: `/tenant/${id}/utente/disabilita`, method: 'put', loadingBar: true })
}
